module.exports = __webpack_public_path__ + "static/media/bg-left-img.c83dc045.jpg";